import { CartViewModel, LineItemViewModel, ProductViewModel } from '@/types/api'

import { multiStringHandler } from './multi-string-handler'

import { KeyPathType } from '../types'

export function generateBreadcrumbs(productData: ProductViewModel) {
    const breadcrumbs: {
        item_category1?: string
        item_category2?: string
        item_category3?: string
    } = {}

    const breadcrumb = productData?.breadcrumb

    const isValid = (value?: string | null): value is string => typeof value === 'string' && value.trim() !== ''

    if (Array.isArray(breadcrumb) && breadcrumb.length > 0) {
        if (isValid(breadcrumb[0]?.nameFa)) {
            breadcrumbs.item_category1 = breadcrumb[0]!.nameFa!
        }
        if (isValid(breadcrumb[1]?.nameFa)) {
            breadcrumbs.item_category2 = breadcrumb[1]!.nameFa!
        }
        if (isValid(breadcrumb[2]?.nameFa)) {
            breadcrumbs.item_category3 = breadcrumb[2]!.nameFa!
        }
    }

    return breadcrumbs
}

export function generateProductVariants(
    product: ProductViewModel | null,
    cart: CartViewModel | null,
    variants: LineItemViewModel[] | null,
    items: KeyPathType[]
): Record<string, string> {
    let variantList
    if (product) {
        variantList = product.variants
    } else if (cart) {
        variantList = cart.items
    } else {
        variantList = variants
    }
    const result: Record<string, string> = {}

    for (const item of items) {
        const value = multiStringHandler(variantList ?? [], item)
        result[item] = typeof value === 'string' && value.trim() !== '' ? value : 'Blank'
    }

    return result
}
